// import { process } from 'global';

const isSpainTenant =
  typeof window !== 'undefined' &&
  process.env.REACT_APP_TENANT?.includes('spain');

const colors: Record<string, string> = {
  aerospace: '#FF5100',
  white: '#FFFFFF',
  black: '#000000',
  chineseBlack: '#121212',
  eerieBlack: '#1B1B1B',
  raisinBlack: '#262626',
  cyan: '#00B2E3',

  darkBlue: '#292935',
  darkGoku: '#19191C',
  greyText: '#999999',
  primaryRed: isSpainTenant ? '#B58344' : '#F73535',
  primaryBrown: '#231F20',
  primaryBlue: '#316EF7',
  activeBlue: '#88B3FF',
  secondaryBlue: '#535374',
  OlybetSecondaryBlue: '#33CFFF',
  OlybetGrey07: '#BDBDBD',

  gradientOlybet: isSpainTenant
    ? 'linear-gradient(279deg, #B58344 13.3%, #33CFFF 86.79%)'
    : 'linear-gradient(279deg, #F73535 13.3%, #33CFFF 86.79%)',
};

export default colors;
